<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            
            <onboarding-header [step]="step"></onboarding-header>

            <div class="content mt-0 mt-md-3">
                <div>
                    <div class="form-group title mt-4">
                        <h4 class="text-center">{{ 'onboarding.aboutyou.description' | translate}}</h4>
                    </div>
                    <form class="form-horizontal col-md-10 mx-auto" name="aboutyouForm" [formGroup]="form" (ngSubmit)="register()">
                        <div class="form-group row py-1">
                            <label class="col-form-label col-md-4 text-md-end" for="firstName">{{'firstName' | translate}}</label>
                            <div class="col-md-4">
                                <input type="text" id="firstName" name="firstName" 
                                       formControlName="firstName" class="form-control">
                            </div>
                            @if (firstName.invalid && (firstName.dirty || firstName.touched)) {
                                @if (firstName.errors?.['required']) {
                                  <div class="text-danger pt-2 col-md-4">{{'error.required' | translate}}</div>
                                }
                                @if (firstName.errors?.['minlength']) {
                                    <div class="text-danger pt-2 col-md-4">{{'error.minLengthTwo' | translate}}</div>
                                }
                            }
                        </div>
                
                        <div class="form-group row py-1">
                            <label class="col-form-label col-md-4 text-md-end" for="lastName">{{'lastName' | translate}}</label>
                            <div class="col-md-4">
                                <input type="text" id="lastName" name="lastName" 
                                       formControlName="lastName" class="form-control">
                            </div>
                            @if (lastName.invalid && (lastName.dirty || lastName.touched)) {
                                @if (lastName.errors?.['required']) {
                                  <div class="text-danger pt-2 col-md-4">{{'error.required' | translate}}</div>
                                }
                                @if (lastName.errors?.['minlength']) {
                                    <div class="text-danger pt-2 col-md-4">{{'error.minLengthTwo' | translate}}</div>
                                }
                            }
                        </div>
                
                        <div formGroupName="passwordSubForm">
                            <div class="form-group row py-1">
                                <label class="col-form-label col-md-4 text-md-end" for="password.password1">{{'password.password1' | translate}}</label>
                                <div class="col-md-4">
                                    <input type="password" id="password.password1" name="password1" data-cy="password1" 
                                           formControlName="password1" class="form-control">
                                </div>
                                @if (password1.invalid && (password1.dirty || password1.touched)) {
                                    @if (password1.errors?.['required']) {
                                        <div class="text-danger pt-2 col-md-4">{{'error.required' | translate}}</div>
                                    }
                                }
                            </div>
                    
                            <div class="form-group row py-1">
                                <label class="col-form-label col-md-4 text-md-end" for="password.password2">{{'password.password2' | translate}}</label>
                                <div class="col-md-4">
                                    <input type="password" id="password.password2" name="password2" data-cy="password2" 
                                           formControlName="password2" class="form-control">
                                </div>
                                @if (password2.invalid && (password2.dirty || password2.touched)) {
                                    @if (password2.errors?.['required']) {
                                        <div class="text-danger pt-2 col-md-4">{{'error.required' | translate}}</div>
                                    }
                                }
                            </div>
                            
                        </div>
                       
                
                        <div class="form-group row py-2">
                            <div class="col-md-4"></div>
                            <div class="checkbox form-check ps-4 ms-2 col-md-7 pb-3">
                                <input class="form-check-input" type="checkbox" formControlName="terms" id="terms">
                                <label class="form-check-label" for="terms">
                                    {{'signup.accept_terms' | translate}} <a href="https://www.teammood.com/en/terms-of-service/" target="_blank">{{'terms_of_use' | translate}}.</a>
                                </label>
                            </div>

                            <!-- general errors messages at the end of the form -->
                            @if ((password1.invalid && (password1.dirty || password1.touched))) {
                                @if (password1.errors?.['password']) {
                                    <div class="col-md-2"></div>
                                    <div class="alert alert-warning col-md-8 text-center fst-italic mb-1">{{'error.password_format' | translate}}</div>
                                    <div class="col-md-2"></div>
                                }
                            }
                            @if(passwordSubForm.errors?.['PasswordNoMatch'] && (password2.dirty || password2.touched)){
                                <div class="col-md-2"></div>
                                <div class="alert alert-warning col-md-8 text-center fst-italic mb-1">
                                    {{'error.password_no_match' | translate}}
                                </div>
                            }
                        </div>
                        
                
                        <div class="form-group form-actions row">
                            <div class="col-md-8"></div>
                            <div class="col-md-2">
                                <button class="btn btn-primary btn-lg btn-next" [disabled]="!form.valid"
                                        type="submit">
                                    {{'next' | translate}} <i class="far fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>